import React from 'react';
import { TLinkProps, TParagraphProps, TTextProps, TTitleProps } from './Typography.types';
import { SLink, SParagraph, SSecondaryText, SText, STitle } from './Typography.styles';

export const Title = (props: TTitleProps) => {
  return <STitle {...props} />;
};

export const Text = (props: TTextProps) => {
  return <SText {...props} />;
};

export const SecondaryText = (props: TTextProps) => {
  return <SSecondaryText {...props} />;
};

export const Link = ({ href, onClick, ...rest }: TLinkProps) => {
  const handleClick = href
    ? (e: React.MouseEvent<HTMLElement>) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        onClick?.(e);
      }
    : onClick;

  return <SLink {...rest} href={href} onClick={handleClick} />;
};

export const Paragraph = (props: TParagraphProps) => {
  return <SParagraph {...props} />;
};
